import { render, staticRenderFns } from "./PromotionComponent.vue?vue&type=template&id=6731eced"
import script from "./PromotionComponent.vue?vue&type=script&lang=js"
export * from "./PromotionComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports